/*
 * @Description: 小票模板管理
 * @Author: Roger Wei
 * @Date: 2021-11-28 13:32:42
 * @LastEditTime: 2021-11-28 15:00:49
 * @LastEditors: Roger Wei
 * @CopyRight: itence.com
 * @Reference: 
 */
import request from "@/utils/request";
const baseUri = '/icps/system/sign/basics/smallTicketTemplate/'

// 获取模板列表
export function getTicketTemplateList(data) {
    return request({
        url: baseUri + 'QueryPage',
        method: 'post',
        data
    })
}

// 添加、编辑模板库的模板
export function saveOrUpdateTicketTemplate(data) {
    return request({
        url: baseUri + 'saveOrUpdate',
        method: 'post',
        data
    })
}

// 删除模板
export function delTicketTemplate(data) {
    return request({
        url: baseUri + 'deleteTemplate',
        method: 'post',
        data
    })
}

/// 站点
const siteBaseUri = '/icps/system/sign/basics/stationTemplate/'

// 获取站点模板列表
export function getSiteTicketTemplateList(data) {
    return request({
        url: siteBaseUri + 'queryPage',
        method: 'post',
        data
    })
}
// 获取站点模板列表（只用于添加小票管理界面的list）
export function querySmallTicketTemplate(data){
    return request({
        url: siteBaseUri + 'querySmallTicketTemplate',
        method: 'post',
        data
    })
}
//添加站点模板
export function insertStationSmallTicketTemplate(data) {
    return request({
        url: siteBaseUri + 'insertStationSmallTicketTemplate',
        method: 'post',
        data
    })
}
//删除站点模板
export function delSmallTicketTemplate(params) {
    return request({
        url: siteBaseUri + 'delSmallTicketTemplate',
        method:'get',
        params
    })
}
// 设置站点模板优先级
export function saveOrUpdatePriority(data) {
    return request({
        url: siteBaseUri + 'saveOrUpdateTemp',
        method: 'post',
        data
    })
}



// 设置使用条件
export function saveCondition(data) {
    return request({
        url: siteBaseUri + 'saveCondition',
        method: 'post',
        data
    })
}


// 用于其他站点
export function useToSite(data) {
    return request({
        url: siteBaseUri + 'updateOtherStation',
        method: 'post',
        data
    })
}


// 获取站点模板
export function getConditionList(data) {
    return request({
        url: siteBaseUri + 'getCondition',
        method: 'post',
        data
    })
}

